export default __webpack_public_path__ + "assets/ico_vote-3ed3e8a9.svg";